<!--Main Border-->
<div class="MainBorder">
	<div class="Scroll">
		<caass-time-scan-entry *ngFor="let o of lstScans" [ScanInfo]="o"> </caass-time-scan-entry>
	</div>
</div>
